var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.6667 3.41667V5.25C17.6667 5.91667 17.2501 6.75 16.8334 7.16667L13.2501 10.3333C12.7501 10.75 12.4167 11.5833 12.4167 12.25V15.8333C12.4167 16.3333 12.0834 17 11.6667 17.25L10.5001 18C9.41675 18.6667 7.91675 17.9167 7.91675 16.5833V12.1667C7.91675 11.5833 7.58342 10.8333 7.25008 10.4167L6.41675 9.54167L11.2667 1.75H16.0001C16.9167 1.75 17.6667 2.5 17.6667 3.41667Z",
    fill: "#001628"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91659 1.75L5.59992 8.675L4.08325 7.08333C3.66659 6.66667 3.33325 5.91667 3.33325 5.41667V3.5C3.33325 2.5 4.08325 1.75 4.99992 1.75H9.91659Z",
    fill: "#001628"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.08f0296a847804bba6ebc8a6f5fd24b6.svg";
export { ForwardRef as ReactComponent };